import styles from "./AccountPreference.scss";
import { getLocalizedStrings } from "../centralizedLocalizedString";
import Header from "./Presentational/Header";
import WebUser from "./Presentational/webUser";
import MyAccountUser from "./Presentational/myAccountUser";
import GlobalErrorCard from "./Presentational/GlobalErrorCard";

class AccountPreference extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("AccountPreference");
    this.state = {
      data: {
        marketingPref: [], contractAccountResults: [],
      },
      accountDetails: {
        Name: "", contractAccountNumber: "", contractNumber: "", postBoxNumber: "", houseNumber: "", premiseNumber: "", streetAddress: "", city: "", state: "",
        zipcode: "", obEnrollmentFlag: "", isEligible: "", nextStatementDate: "", onlyOneBpEnrolled: "", reason: "", mainBpNumber: "", supplement:"",
      },
      preferenceDetails: [{
        papr: {email_id: []},
        outg: {email_id: [],phoneNo: [],textNo: [],directMail: null},
        emrg: {email_id: [],phoneNo: [],textNo: [],},
        buda: {email_id: [],phoneNo: [],textNo: []},
        cpp: {email_id: [],phoneNo: [],textNo: []}
      }],
      singlePaprRecord: { record: [] }, desinglePaprRecord: { record: [] },
      formattedDataForOutg: { email_id: [], phoneNo: [], textNo: [],directMail: null},      
      formattedDataForEmrg: { email_id: [], phoneNo: [], textNo: [] },    
      formattedDataForBuda: { email_id: [], phoneNo: [], textNo: [] },
      errorCard: undefined, isWebUser: false, showError: false, refreshPref: "", errorResponse: "", emailPref: "", isContractNull: false, Name: "",
      bpNumber: "", prefDet: "", dropDownData: "",
      ebillpaprCount : "", ebillpaprRecord: {record:[]}, ebillpaprSold:{record:[]}, ebillpaprAuth:{record:[]}
    }; }

  componentWillMount() {
    this.setState(
      {
        data: this.props.data,
        customerData: this.props.customerData,
        Name: this.props.data.bpName,
        bpNumber: this.props.data.bpNumber,
        isWebUser: this.props.isWebUser,
        obEnrollmentFlag: this.props.obEnrollmentFlag,
        isEligible: this.props.isEligible,
        reason: this.props.reason,
        errorResponse: this.props.errorResponse,
        isContractNull: this.props.data.contractAccountResults.length ? false : true
      },
      () => {this.handle();}
    );
  }

  launchErrorModal = () => {
    if (this.state.errorResponse.length) {
      let maps = new Map(this.state.errorResponse.map(o => [o.programDetails, o]));
      let programError = maps.get("CPC_PROGRAMS");
      if (!_.isEmpty(programError)) {
        return programError.errorFlag;
      } } }

  handle = () => {
    let updatedState = { ...this.state };
    updatedState.showError = this.launchErrorModal();
    if (this.state.data.contractAccountResults.length) {
      let filtered = this.state.data.contractAccountResults[0];
      updatedState.prefDet = filtered;
      updatedState.accountDetails.contractAccountNumber = filtered.contractAccountNumber;
      updatedState.accountDetails.Name = filtered.bpName;
      updatedState.accountDetails.obEnrollmentFlag = filtered.obEnrollmentFlag;
      updatedState.accountDetails.isEligible = filtered.isEligible;
      updatedState.accountDetails.reason = filtered.reason;
      updatedState.accountDetails.nextStatementDate = filtered.nextStatementDate;
      updatedState.accountDetails.bpNumber = filtered.bpNumber;
      updatedState.accountDetails.postBoxNumber= filtered.postBoxNumber&& filtered.postBoxNumber!==''? filtered.postBoxNumber : '';
      updatedState.accountDetails.bpCategory = filtered.bpCategory;
      this.onPbToggleOnOffClick(updatedState.accountDetails.bpNumber, updatedState.accountDetails.contractAccountNumber);

      var pref;
      if (this.state.data.contractAccountResults.length) {
        pref = this.state.data.contractAccountResults[0];
        updatedState.accountDetails.contractNumber = filtered.contractResults[0].contractNumber;
        updatedState.accountDetails.houseNumber = pref.houseNumber;
        updatedState.accountDetails.premiseNumber = filtered.contractResults[0].premiseNumber;
        updatedState.accountDetails.streetAddress = pref.contractAccountStreetAddress;
        updatedState.accountDetails.city = pref.city;
        updatedState.accountDetails.state = pref.state;
        updatedState.accountDetails.zipcode = pref.zipCode;
        updatedState.accountDetails.onlyOneBpEnrolled = filtered.contractResults[0].onlyOneBpEnrolled;
        updatedState.accountDetails.supplement = pref.unitNumber;


        //email pref 
        if (filtered.contractResults[0].emailPreferences !== null && this.state.showError === false) {
          this.setEmailPreference(filtered.contractResults[0].emailPreferences);
        }
        //phone pref 
        if (filtered.contractResults[0].phonePreferences !== null && this.state.showError === false) {
          this.setPhonePreference(filtered.contractResults[0].phonePreferences);
        }
        //text pref 
        if (filtered.contractResults[0].textPreferences !== null && this.state.showError === false) {
          this.setTextPreference(filtered.contractResults[0].textPreferences);
        }
        //directMail pref
        updatedState = this.setDirectMailLetterPreference(updatedState, filtered.contractResults[0].directMailLetterPreference);
      }
    }
    else {
      updatedState.isContractNull = true;
    }
    updatedState.dropDownData = app.appService.getSessionstorage('dropDownData');
    this.setState(updatedState);
  };
  setDirectMailLetterPreference(updatedState, directMailLetterPreference){
    updatedState.preferenceDetails[0].outg.directMail = (directMailLetterPreference && directMailLetterPreference.record_guid) ? directMailLetterPreference : null;
    updatedState.formattedDataForOutg.directMail = (directMailLetterPreference && directMailLetterPreference.record_guid) ? directMailLetterPreference : null;
    return updatedState;
  }

  setEmailPreference(preferences) {
    const updatedState = { ...this.state };
    updatedState.preferenceDetails[0].papr.email_id = [];
    updatedState.preferenceDetails[0].outg.email_id = [];
    updatedState.preferenceDetails[0].emrg.email_id = [];
    updatedState.preferenceDetails[0].buda.email_id = [];
    updatedState.preferenceDetails[0].cpp.email_id = [];
    updatedState.formattedDataForOutg.email_id = [];
    updatedState.formattedDataForEmrg.email_id = [];
    updatedState.formattedDataForBuda.email_id = [];
    preferences.map((emailSearch) => {
      if (emailSearch.category === "PAPR" && emailSearch.messageType === "EBIL") {
        updatedState.preferenceDetails[0].papr.email_id.push(emailSearch.email_id);
        updatedState.singlePaprRecord.record.push(emailSearch);
        updatedState.desinglePaprRecord.record.push(emailSearch);
      } else if (emailSearch.category === "OUTG" && emailSearch.messageType === "OUTG") {
        updatedState.preferenceDetails[0].outg.email_id.push(emailSearch.email_id);
        updatedState.formattedDataForOutg.email_id.push(emailSearch);
      } else if (emailSearch.category === "OUTG" && emailSearch.messageType === "EMRG") {
        updatedState.preferenceDetails[0].emrg.email_id.push(emailSearch.email_id);
        updatedState.formattedDataForEmrg.email_id.push(emailSearch);
      } else if (emailSearch.category === "PROG" && emailSearch.messageType === "BUDA") {
        updatedState.preferenceDetails[0].buda.email_id.push(emailSearch.email_id);
        updatedState.formattedDataForBuda.email_id.push(emailSearch);
      } else if (emailSearch.category === "DEMR" && emailSearch.messageType === "CPP1") {
        updatedState.preferenceDetails[0].cpp.email_id.push(emailSearch.email_id);
      }
    });
    this.setState(updatedState);
  }

  setPhonePreference(preferences) {
    const updatedState = { ...this.state };
    updatedState.preferenceDetails[0].outg.phoneNo = [];
    updatedState.preferenceDetails[0].emrg.phoneNo = [];
    updatedState.preferenceDetails[0].buda.phoneNo = [];
    updatedState.preferenceDetails[0].cpp.phoneNo = [];
    updatedState.formattedDataForOutg.phoneNo = [];
    updatedState.formattedDataForEmrg.phoneNo = [];
    updatedState.formattedDataForBuda.phoneNo = [];
    preferences.map((phnSearch) => {
      if (phnSearch.category === "PAPR" && phnSearch.messageType === "EBIL") {
        updatedState.preferenceDetails[0].papr.phoneNo.push(phnSearch.maskedPhoneNumber);
      } else if (phnSearch.category === "OUTG" && phnSearch.messageType === "OUTG") {
        updatedState.preferenceDetails[0].outg.phoneNo.push(phnSearch.maskedPhoneNumber);
        updatedState.formattedDataForOutg.phoneNo.push(phnSearch);
      } else if (phnSearch.category === "OUTG" && phnSearch.messageType === "EMRG") {
        updatedState.preferenceDetails[0].emrg.phoneNo.push(phnSearch.maskedPhoneNumber);
        updatedState.formattedDataForEmrg.phoneNo.push(phnSearch);
      } else if (phnSearch.category === "PROG" && phnSearch.messageType === "BUDA") {
        updatedState.preferenceDetails[0].buda.phoneNo.push(phnSearch.maskedPhoneNumber);
        updatedState.formattedDataForBuda.phoneNo.push(phnSearch);
      } else if (phnSearch.category === "DEMR" && phnSearch.messageType === "CPP1") {
        updatedState.preferenceDetails[0].cpp.phoneNo.push(phnSearch.maskedPhoneNumber);
      }
    });
    this.setState(updatedState);
  }

  setTextPreference(preferences) {
    const updatedState = { ...this.state };
    updatedState.preferenceDetails[0].outg.textNo = [];
    updatedState.preferenceDetails[0].emrg.textNo = [];
    updatedState.preferenceDetails[0].buda.textNo = [];
    updatedState.preferenceDetails[0].cpp.textNo = [];
    updatedState.formattedDataForOutg.textNo = [];
    updatedState.formattedDataForEmrg.textNo = [];
    updatedState.formattedDataForBuda.textNo = [];
    preferences.map((txtSearch) => {
      if (txtSearch.category === "PAPR" && txtSearch.messageType === "EBIL") {
        updatedState.preferenceDetails[0].papr.textNo.push(txtSearch.maskedText);
      } else if (txtSearch.category === "OUTG" && txtSearch.messageType === "OUTG") {
        updatedState.preferenceDetails[0].outg.textNo.push(txtSearch.maskedText);
        updatedState.formattedDataForOutg.textNo.push(txtSearch);
      } else if (txtSearch.category === "OUTG" && txtSearch.messageType === "EMRG") {
        updatedState.preferenceDetails[0].emrg.textNo.push(txtSearch.maskedText);
        updatedState.formattedDataForEmrg.textNo.push(txtSearch);
      } else if (txtSearch.category === "PROG" && txtSearch.messageType === "BUDA") {
        updatedState.preferenceDetails[0].buda.textNo.push(txtSearch.maskedText);
        updatedState.formattedDataForBuda.textNo.push(txtSearch);
      } else if (txtSearch.category === "DEMR" && txtSearch.messageType === "CPP1") {
        updatedState.preferenceDetails[0].cpp.textNo.push(txtSearch.maskedText);
      }
    });
    this.setState(updatedState);
  }

  refreshPage = async () => {
    let resp = await this.props.handleRefreshAccPref(this.state.accountDetails.contractAccountNumber, this.state.accountDetails.contractNumber, this.state.accountDetails.premiseNumber, this.state.bpNumber, this.state.accountDetails.bpNumber);
      if(!_.isEmpty(resp) && !resp.errorCode && !resp.errorDescription && !resp.errorType){
      let updateState = { ...this.state };
      updateState.refreshPref = resp;
      updateState.data.cppPreferenceSet = { ...resp.cppPreferenceSet };
      updateState.showError = false;
      updateState.data.baEnrollmentDetailsVO = {...resp.baEnrollmentDetailsVO};
      updateState = this.setDirectMailLetterPreference(updateState, updateState.refreshPref.directMailLetterPreference);
      this.setState(updateState, () => {
        this.setEmailPreference(this.state.refreshPref.emailPreferences);
        this.setPhonePreference(this.state.refreshPref.phonePreferences);
        this.setTextPreference(this.state.refreshPref.textPreferences);
      });
    }
    else{
      this.setState({showError:true});
    }
  }
  getToNoAccountsView=()=>{
    return(<div className={styles.NoActView}> {this.strings.NoAccountMsge1}<br /><br />{this.strings.NoAccountMsge2}<a className={styles.LearnMore} href="/mysce/verifypin">{this.strings.LearnMore}</a></div> );
  }

  removePreference = (prefrenceType, formattedPreferenceType)=>{
    let updatedState = {...this.state};
    updatedState.preferenceDetails[0][prefrenceType] = (formattedPreferenceType === 'formattedDataForOutg' ? {email_id: [],phoneNo: [],textNo: [],directMail:null} : {email_id: [],phoneNo: [],textNo: []});
    formattedPreferenceType === 'formattedDataForCpp' ?  updatedState.data.cppPreferenceSet = {addressGuid: "", assignedStatusArray: [], emailSet: [], mobileSet: [], phoneSet: []} :  updatedState[formattedPreferenceType] = {email_id:[],phoneNo:[],textNo:[]};
    if(formattedPreferenceType === 'formattedDataForOutg') updatedState[formattedPreferenceType] =  {email_id: [],phoneNo: [],textNo: [],directMail: null};
    this.setState(updatedState);
  }

  updateDropDownData = (dropDownData) => {
    app.appService.setSessionstorage('dropDownData',dropDownData);
    this.setState({dropDownData: app.appService.getSessionstorage('dropDownData')});
  }
  onPbToggleOnOffClick(bpNumber, contractAccountNumber){
    let updatedState = { ...this.state };
    let ebillpaprRecord={record:[]}, ebillpaprSold={record:[]}, ebillpaprAuth={record:[]};
    let mainBpNumber = app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber;
    app.centralizedService.geteBillPreferencesContractAccountPref(bpNumber, contractAccountNumber, this.state.isWebUser).then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== "") {
        //to be completed
        //this.setState({ errorCard: true, });
      } else {
        let res=response.customerEbillPreferences.results[0].qryObjSumQryBPChnlSumNav.results;
        app.appService.setSessionstorage('pbBuPartner', res[0].buPartner);
        app.appService.setSessionstorage('pbBuPartner2', res[0].buPartner2);
        res.map((record) => {
          let results=record.qryBPChnlSumQryPreSumNav.results;
            results.map((result) => {
              ebillpaprRecord.record.push(result);
             (mainBpNumber === record.buPartner || record.buPartner2) ? ebillpaprSold.record.push(result) : ebillpaprAuth.record.push(result);
              });
          });
        this.setState({ebillpaprRecord:ebillpaprRecord, ebillpaprSold: ebillpaprSold, ebillpaprAuth: ebillpaprAuth, ebillpaprCount: response.customerEbillPreferences.results[0].count });}
    });
  }
  render() {
    //alert("c"+JSON.stringify(this.state.singlePaprRecord));
    return (
      <div>
        <div className={styles.ConHeading}>{this.strings.AccountPreferenceLabel}</div>
        {(this.state.isContractNull) ?
        <div>
          {this.state.isWebUser ?<div>{this.getToNoAccountsView()}</div> :
          <GlobalErrorCard
            message={this.strings.errMsg}
            refreshPage={this.refreshPage}
          />}
          </div>
          :
          <div>
            {(this.state.showError) ?
              <GlobalErrorCard
                message={this.strings.errMsg}
                refreshPage={this.refreshPage}
              /> :
              <div>
                <Header accountDetails={this.state.accountDetails} />
                {(this.state.isWebUser) ?
                  <WebUser
                    accountDetails={this.state.accountDetails}
                    cpcData={this.state.data} dropDownData={this.state.dropDownData}
                    preferenceDetails={this.state.preferenceDetails} updateDropDownData={this.updateDropDownData}
                    formattedDataForOutg={this.state.formattedDataForOutg}
                    formattedDataForEmrg={this.state.formattedDataForEmrg}
                    refreshPage={this.refreshPage} removePreference={this.removePreference}
                    isWebUser={this.state.isWebUser} staticContent={this.props.staticContent} />
                  : <MyAccountUser
                    prefDetails={this.state.prefDet} cpcData={this.state.data} dropDownData={this.state.dropDownData}
                    accountDetails={this.state.accountDetails} updateDropDownData={this.updateDropDownData}
                    preferenceDetails={this.state.preferenceDetails}
                    customerData={this.state.customerData}
                    refreshPage={this.refreshPage} removePreference={this.removePreference} ebillpaprCount={this.state.ebillpaprCount} onPbToggleOnOffClick={this.onPbToggleOnOffClick}
                    singlePaprRecord={this.state.singlePaprRecord} desinglePaprRecord={this.state.desinglePaprRecord} ebillpaprRecord={this.state.ebillpaprRecord}
                    ebillpaprSold={this.state.ebillpaprSold} ebillpaprAuth={this.state.ebillpaprAuth}
                    formattedDataForOutg={this.state.formattedDataForOutg} formattedDataForEmrg={this.state.formattedDataForEmrg} 
                    formattedDataForBuda={this.state.formattedDataForBuda} staticContent={this.props.staticContent} billingRateType={this.props.billingRateType} />}
              </div>
            }
          </div>}
      </div>
    );
  }
}
export default AccountPreference;
